<template>
  <div class="row mb-5 border-bottom pb-3">
    <div class="col-12 col-md-5 align-self-center">
        <h3>{{$t('departamentos_graph_h3')}}</h3>
    </div>

    <div class="col-12 col-md-7">
      <highcharts class="packedbubble" :options="packedbubbleOptions"></highcharts>
    </div>
  </div>
</template>

<style lang="scss">

</style>

<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import streamgraph from 'highcharts/modules/streamgraph'
  import { map, groupBy, orderBy } from 'lodash'

  more(Highcharts)
  streamgraph(Highcharts)

  export default {
    name: 'departamentosGraph',
    props: {
      dataset: Array
    },
    components: {
      highcharts: Chart
    },
    computed: {
      packedbubbleOptions() {
        return {
          chart: {
            backgroundColor: 'transparent',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'bar'
          },
          title: {
            text: ''
          },
          legend: {
            enabled: false
          },
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y} PMF</b>'
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          yAxis: {
            visible: false,
            labels: {
              enabled: false
            }
          },
          xAxis: {
            labels: {
              enabled: false
            }
          },
          plotOptions: {
            series: {
              dataLabels: {
                pointFormat: '<span class="label-graph-ranking">{point.name} ({point.y} PMF)</span>',
                align: 'left',
                enabled: true,
                useHTML: true
              },
              pointPadding: 0,
              groupPadding: 0.1
            }
          },
            series: [{
              name: 'Departamentos',
              color: '#2e7832',
              data: orderBy(this.n_data, ['y'], ['desc'])
          }]
        }
      },
      n_data() {
        return orderBy(map(groupBy(this.dataset, 'departamento'), (item, dep) =>  {
          return {
            name: dep,
            y: item.length,
          }
        }), ['y'], ['desc'])
      }
    }
  }
</script>